import { HiddenA11yText } from 'app/components/Link/Link.styles';
import React from 'react';
import {
    StyledSurvey,
    StyledThankYou,
    ThankYouHeading,
    StyledThankYouImage,
    ThankYouTextContainer,
    CloseButton,
    FixedContainer,
} from './StyledSurvey.styles';

type Props = {
    survey: any; // Add Contento type here when its available
    onCloseSurvey: (id: number) => void;
};

const ThankYou = ({ survey, onCloseSurvey }: Props) => {
    return (
        <FixedContainer>
            <StyledThankYou>
                <StyledThankYouImage></StyledThankYouImage>
                <StyledSurvey>
                    <ThankYouTextContainer>
                        <ThankYouHeading>Tack så mycket för ditt svar!</ThankYouHeading>
                    </ThankYouTextContainer>
                    <CloseButton
                        type="button"
                        onClick={() => {
                            onCloseSurvey(survey.id);
                        }}
                    >
                        <HiddenA11yText>Stäng enkät</HiddenA11yText>
                    </CloseButton>
                </StyledSurvey>
            </StyledThankYou>
        </FixedContainer>
    );
};

export default ThankYou;
